import zoomCircleLogo from 'assets/images/zoom-tcap.svg';
import teamsCircleLogo from 'assets/images/teams.svg';
import WebEx_Circle from 'assets/images/webex.svg';
import Azure_Circle from 'assets/images/acs.svg';
import Sip_TaaS_Circle from 'assets/images/sbcaas.svg';
import eightByEightLogo from 'assets/images/8x8-tcap.svg';
import GCCHighLogo from 'assets/images/gcc-high.png';
import RingCentralLogo from 'assets/images/ring-central.svg';
import DialPadLogo from 'assets/images/dialpad.png';
import OperatorPlatformLogo from 'assets/images/pingco_logo_small.png';
import InfoIcon from 'assets/images/info.png';
import { CLOUD_SIP_LABEL } from '@/constants/sbcaas';

const Platforms = {
    '6bf86774-7374-4bc3-a113-0d179f3b1488': {
        name: 'Azure Communication Services',
        icon: Azure_Circle,
        id: '6bf86774-7374-4bc3-a113-0d179f3b1488',
    },
    '757c2ae9-ee8d-42a9-bf89-351a4f797484': {
        name: 'Cisco Webex',
        icon: WebEx_Circle,
        id: '757c2ae9-ee8d-42a9-bf89-351a4f797484',
    },
    '46140cdd-5134-4088-b474-9aad13987c9f': {
        name: 'Zoom',
        icon: zoomCircleLogo,
        id: '46140cdd-5134-4088-b474-9aad13987c9f',
    },
    '5873b368-64b4-4262-829a-a626cef2f4f6': {
        name: CLOUD_SIP_LABEL,
        icon: Sip_TaaS_Circle,
        id: '5873b368-64b4-4262-829a-a626cef2f4f6',
    },
    'fac64979-385b-42ce-8b1c-d30e87822304': {
        name: 'Microsoft Teams',
        icon: teamsCircleLogo,
        id: 'fac64979-385b-42ce-8b1c-d30e87822304',
    },
    ms_resource_account: {
        name: 'Microsoft Resource Account',
        icon: teamsCircleLogo,
        id: 'ms_resource_account',
    },
    ms_resource_account_gcch: {
        name: 'Microsoft Resource Account GCCH',
        icon: GCCHighLogo,
        id: 'ms_resource_account_gcch',
    },
    '86394d2a-acdd-4923-8623-dcae7541e641': {
        name: '8x8',
        icon: eightByEightLogo,
        id: '86394d2a-acdd-4923-8623-dcae7541e641',
    },
    'b8369b29-823d-4b3d-a12f-4f708993d0a8': {
        name: 'Microsoft (GCC High)',
        icon: GCCHighLogo,
        id: 'b8369b29-823d-4b3d-a12f-4f708993d0a8',
    },
    'd7718d8c-360f-479d-a3ba-ee05034be03e': {
        name: null,
        icon: OperatorPlatformLogo,
        id: 'd7718d8c-360f-479d-a3ba-ee05034be03e',
    },
    '4b00e1e5-ab6f-4e45-9c10-2a7ee43dcc5b': {
        name: 'Ring Central',
        icon: RingCentralLogo,
        id: '4b00e1e5-ab6f-4e45-9c10-2a7ee43dcc5b',
    },
    'dfdb6dc1-7dd0-49f8-b550-7b5468996d95': {
        name: 'Dial Pad',
        icon: DialPadLogo,
        id: 'dfdb6dc1-7dd0-49f8-b550-7b5468996d95',
    },
    numbers: {
        name: 'Numbers',
        icon: InfoIcon,
        id: 'numbers',
    },
    priority: {
        name: 'Priority',
        icon: InfoIcon,
        id: 'priority',
    },
};

export const PlatformEnums = {
    AZURE: '6bf86774-7374-4bc3-a113-0d179f3b1488',
    WEBEX: '757c2ae9-ee8d-42a9-bf89-351a4f797484',
    ZOOM: '46140cdd-5134-4088-b474-9aad13987c9f',
    SBC: '5873b368-64b4-4262-829a-a626cef2f4f6',
    TEAMS: 'fac64979-385b-42ce-8b1c-d30e87822304',
    EIGHTBYEIGHT: '86394d2a-acdd-4923-8623-dcae7541e641',
    GCC: 'b8369b29-823d-4b3d-a12f-4f708993d0a8',
    OPERATOR_PLATFORM: 'd7718d8c-360f-479d-a3ba-ee05034be03e',
    RINGCENTRAL: '4b00e1e5-ab6f-4e45-9c10-2a7ee43dcc5b',
    DIALPAD: 'dfdb6dc1-7dd0-49f8-b550-7b5468996d95',
};

export default Platforms;
